module.exports = __webpack_public_path__ + "img/004.d32ba712.png";